<template>
  <section class="app-main" :style="isBackColor?'background: #f0f2f5':''">
    <router-view v-slot="{ Component }">
      <transition name="fade-transform" mode="out-in">
          <component :is="Component"/>
      </transition>
    </router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    },
    isBackColor () {
      if (process.env.NODE_ENV === 'development') {
        return false
      } else if (process.env.NODE_ENV === 'production') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
//   background-image: linear-gradient(
// 120deg, #e3d9ec 0%, #8ec5fc 100%);
  height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: auto;
  padding: 20px;
  background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  box-sizing: border-box;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
